var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "filter-control"
  }, [_c('filter-by-period', {
    attrs: {
      "label": 'Obdobie'
    },
    on: {
      "period-filter-change": function periodFilterChange($event) {
        return _vm.$emit('period-filter-change', $event);
      },
      "period-statistic-change": function periodStatisticChange($event) {
        return _vm.$emit('period-statistic-change', $event);
      }
    }
  }), _vm.role === 'alex_admin' ? _c('filter-by-employee', {
    attrs: {
      "label": 'bankár',
      "employees": _vm.financnici
    },
    on: {
      "employee-filter-change": function employeeFilterChange($event) {
        return _vm.$emit('broker-filter-change', $event);
      }
    }
  }) : _vm._e(), _c('search-by-key', {
    on: {
      "filter-client-by-key": function filterClientByKey($event) {
        return _vm.$emit('filter-client', $event);
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }